import React from 'react';

import {WORKSPACE_MEDIA_SETTINGS_DESCRIPTION} from '../constants';
import {MediaWorkspaceSettingsContextProvider} from './contexts/MediaWorkspaceSettingsContextProvider';
import {MediaSettingsDrawerContent} from './MediaSettingsDrawerContent';
import {SettingsLevel} from './types';

export const WorkspaceMediaSettingsDrawer = ({
  header,
}: {
  header: React.ReactNode;
}) => {
  return (
    <MediaWorkspaceSettingsContextProvider>
      <MediaSettingsDrawerContent
        header={header}
        description={WORKSPACE_MEDIA_SETTINGS_DESCRIPTION}
        settingsLevel={SettingsLevel.WORKSPACE}
      />
    </MediaWorkspaceSettingsContextProvider>
  );
};
